export default "__VITE_ASSET__fHNsXX0R__"